import React from 'react';

const Alert = ({ children, variant = 'default', className = '' }) => {
  const variantStyles = {
    default: 'bg-blue-100 text-blue-900 border-blue-200',
    destructive: 'bg-red-100 text-red-900 border-red-200',
    warning: 'bg-yellow-100 text-yellow-900 border-yellow-200',
    success: 'bg-green-100 text-green-900 border-green-200'
  };

  return (
    <div className={`p-4 rounded-lg border ${variantStyles[variant]} ${className}`}>
      {children}
    </div>
  );
};

export default Alert;